import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class AppearOnScroll {

	static init() {
		const items = document.querySelectorAll('[data-aos] , .btn-go,  .not-animated-line');
		items.forEach(item => {
			const start = item.dataset.start || "top 90%";
			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: item,
					start: start
				},
			});
			timeline.to(item, { delay: parseFloat(0), onComplete: () => item.classList.add("appeared") });
		});

		setTimeout(()=>{
			ScrollTrigger.refresh();
		}, 300)

		const richTextsElements = document.querySelectorAll('.rich-text > *:not(.title-level-1)');
		gsap.set(richTextsElements, {y: "20%", autoAlpha: 0});
		ScrollTrigger.batch(richTextsElements, {
			onEnter: elem  => {
				gsap.to(elem, {
					y: 0,
					autoAlpha: 1,
					stagger: 0.15,
					duration: 0.8,
					delay: 0.3
				})
			}
		});

		const containers = document.querySelectorAll("[data-appear-container]");
		containers.forEach(container => {
			const children = container.querySelectorAll("[data-appear]");
			gsap.set(children, {y: "20%", autoAlpha: 0});
			ScrollTrigger.batch(children, {
				onEnter: elem  => {
					gsap.to(elem, {
						y: 0,
						autoAlpha: 1,
						stagger: 0.15,
						duration: 0.8
					})
				}
			});
		});
	}
}
